import React from "react";

import { useFeatureToggle } from "@hooks/useFeatureToggle";
import { useStorageExpirationDate } from "@hooks/useStorageExpirationDate";

import type { Props } from "./GiftCardModal.types";
import { info } from "./GiftCardModal.info";

const Modal = React.lazy(() => import("./GiftCardModal"));

export const LazyGiftCardModal: React.FC<Props> = (
  props,
): React.ReactElement => {
  const isGiftCardsAvailable = useFeatureToggle("gift_cards");
  const isFeatureActive = useFeatureToggle("pwa_gift_cards_modal");
  const { isExpired } = useStorageExpirationDate(info.storageKey);

  return (
    <React.Fragment>
      {isGiftCardsAvailable && isFeatureActive && isExpired && (
        <Modal {...props} />
      )}
    </React.Fragment>
  );
};
